import { LeaderBoardScreenConvex } from '@/screens/new-design/LeaderBoardScreenConvex'

export default function () {
  return <LeaderBoardScreenConvex />
}
